module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<header class="header">\r\n    <div class="back-func" id="closedPage">\r\n        <i class="iconfont icon-arrow-left" ></i><span>返回</span>\r\n    </div>\r\n    <h1 class="title">签署合同</h1>\r\n</header>';

}
return __p
}